<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <flight-breadcrumbs :search-request="searchRequest" />
        </template>
        <template v-slot:sidebar>
            <flight-search-summary :search-request="searchRequest" search-disabled />
            <flight-order-summary
                :offer="offer"
                :extra-baggage-options="extraBaggageOptions"
                :flight-seats-map="flightSeatsMap"
                :extra-services="extraServices"
                :search-request="searchRequest"
                :additional-options="bookingAdditionalOptions"
                :prepare-book-response="prepareBookResponse"
            />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {mixins, Component} from 'vue-facing-decorator'
    import ConfirmationStatus from '~src/components/booking/confirmationStatus.src'
    import {FlightPageMixin} from '@/components/flights/mixins/FlightPageMixin.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import FlightSearchSummary from '~/components/flights/search/FlightSearchSummary.vue'
    import FlightOrderSummary from '~/components/flights/booking/FlightOrderSummary.vue'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import FlightBreadcrumbs from '@/components/flights/FlightBreadcrumbs.vue'
    import {FlightStoreMixin} from '@/mixins/FlightStoreMixin'

    //TODO Single confirmation page layout for all services with summary slot
    @Component({
        components: {
            FlightBreadcrumbs,
            ConfirmationPageLayout,
            ConfirmationStatus,
            FlightSearchSummary,
            FlightOrderSummary,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class FlightConfirmationPage extends mixins(FlightPageMixin, ConfirmationPageMixin, FlightStoreMixin) {
        extraBaggageOptions = []
        flightSeatsMap = {}

        async mounted() {
            await this.$store.restored
            const promises = [this.loadAdditionalFlightOptions(this.offer.offerKey)]
            if (!this.isOwnProduct) {
                promises.push(this.loadFlightSeatsMap(this.offer.offerKey))
            }
            await Promise.all(promises)
        }

        async loadAdditionalFlightOptions(offerKey) {
            try {
                const {extraBaggageOptions} = await this.$api.additionalFlightOptions.get({offerKey})
                if (extraBaggageOptions) {
                    this.extraBaggageOptions = extraBaggageOptions
                } else {
                    this.extraBaggageOptions = []
                }
            } catch (e) {
                this.extraBaggageOptions = []
            }
        }

        async loadFlightSeatsMap(offerKey) {
            try {
                const segmentRphs = this.offer.itinerary.map(segmentRphs => segmentRphs)
                const promises = segmentRphs.map(segmentRph => this.$api.flightSeatsMap.get({offerKey, segmentRph}))
                const result = await Promise.all(promises)
                this.flightSeatsMapData = result.reduce((flightSeatsMap, {seatsCabinClasses}, index) => {
                    if (seatsCabinClasses) {
                        flightSeatsMap[segmentRphs[index]] = seatsCabinClasses
                    }
                    return flightSeatsMap
                }, {})
            } catch (e) {
                console.error(e)
                this.flightSeatsMapData = {}
            }
        }

        get basketItem() {
            return flightsStore.basketItem(flightsStore.prepareBookRequest.offerKey)
        }

        get offer() {
            return this.basketItem.offer
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get isOwnProduct() {
            return runtimeStore.ownProduct(this.offer?.supplierCode)
        }
    }

    export default FlightConfirmationPage
</script>
